import Client from '../axiosClient'
const resource = '/enquiry';
const resourceInit = '/enquiry_initialize';
const resourceStatusId = '/enquiry_by_status_id';
const resourceInformCustomer = '/inform_customer';
const resourceAllocate = '/create_packages_for_enquiry';
const resourceHolidayBootstrap = '/customer/home/holiday_request/bootstrap';
const resourceHoliday = '/customer/home/holiday_request';
const resourceCurrency = '/customer/home/currency';
const resourceMessage = '/enquiry_follow_up';
const resourceMessageEnquiryQA = '/enquiry_follow_up_qa';
const resourceBootstrap = '/customer/tour_brochure/booking_initialize';
const resourceUpdateStatus = '/enquiry_change_status';
const resourceAllocatedPartners = '/filter/enquiry_partners';
const resourceAddPackages='/packages';
const resourceAddBooking='/saveBookingId';
const resourceEnquiryCommStatus='/savecommentStatus';

export default {
  init(payload) {
    //return Client.get(`${resourceInit}`);
    let filterParam='';
    if(payload) {
      let filterParam = 'requestFrom='+payload['requestFrom'];
      let dashboardPartnerId = payload['dashboardPartnerId'] != undefined ? payload['dashboardPartnerId'] : "0";
      this.filterParam=filterParam+`&page=${payload['pageNo']}&pageLength=${payload['pageLength']}&dashboardPartnerId=${dashboardPartnerId}&dashboardRoleId=${payload['dashboardRoleId']}&authUserRoleId=${payload['authUserRoleId']}&getAuthUserId=${payload['getAuthUserId']}`;
      return Client.get(`${resourceInit}?${this.filterParam}`);
    }
    return Client.get(`${resourceInit}`);
  },
  bootstrap() {
    return Client.get(`${resourceBootstrap}`);
  },
  holidayInit () {
    return Client.get(`${resourceHolidayBootstrap}`);
  },
  getCurrency () {
    return Client.get(`${resourceCurrency}`);
  },
  get() {
    return Client.get(`${resource}`);
  },
  getById(id) {
    return Client.get(`${resource}/${id}`);
  },
  getByStatusId (payload) {
    return Client.post(`${resourceStatusId}`, payload);
  },

  informCustomer (payload) {
    return Client.post(`${resourceInformCustomer}`, payload);
  },

  AddBooking (payload) {
    return Client.post(`${resourceAddBooking}`, payload);
  },

  savecommentStatus (payload) {
    return Client.post(`${resourceEnquiryCommStatus}`, payload);
  },

  

  post(payload) {
    return Client.post(`${resource}`, payload);
  },

  postHoliday (payload) {
    return Client.post(`${resourceHoliday}`, payload);
  },
  postMessage (payload) {
    return Client.post(`${resourceMessage}`, payload);
  },
  getEnquiryQA(payload) {
    return Client.post(`${resourceMessageEnquiryQA}`, payload);
  },
  allocate(payload) {
    return Client.post(`${resourceAllocate}`, payload);
  },
  updateStatus(payload) {
    return Client.post(`${resourceUpdateStatus}`, payload);
  },
  getEnquiryAllocatedPartners(payload) {
    return Client.post(`${resourceAllocatedPartners}`, payload);
  },
  getPackages(payload)
  {
    return Client.post(`${resourceAddPackages}`, payload);
  }
  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/events/enquiryRepository.js